/**
 *   Interpolate the Y value based on the parameters
 *
 */
export function interpolateValue(x, x1, x2, y1, y2, useDecimals = false) {
    let k = (y2 - y1) / (x2 - x1);
    let m = y1 - k * x1;
    let result = k * x + m;

    // !x should include x === 0 and also fix issues when x is null or undefined.
    if (!x) {
        return 0;
        // if the result is less than 1, return 0
    } else if (!useDecimals && result < 1) {
        return 0;
        // if the result is less than 1, but useDecimals is true, return the result rounded to 2 decimal places
    } else if (useDecimals && result < 1) {
        return roundWithPrecision(result);
        // if the result is greater than or equal to 1, return the result
    } else {
        return result;
    }
}

/**
 * Rounds a number to default 2 decimal places
 */
export function roundWithPrecision(number, precision = 2) {
    const multiple = Math.pow(10, precision);
    return Math.round(number * multiple) / multiple;
}

/**
 * Rounds a giva to whole kg, or to 2 decimals when the user has enabled
 * decimal givor. Previously this rounded to the nearest 10, which silently
 * dropped every giva below 5 kg/ha.
 */
export function roundGiva(giva, useDecimals = false) {
    return useDecimals ? roundWithPrecision(giva) : roundWithPrecision(giva, 0);
}
